import ApiInstance from './instance'

export default class UtilsApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  getAppVersion () {
    return this.instance.doGet('/utils/getAppVersion')
  }
}
